import React from 'react';
import { modules } from '../data/modules';
export function ModulesSection() {
  return <section className="bg-white px-5 py-20" data-id="element-105" data-mp="1nuxtv0c8ezz0">
      <div className="mx-auto max-w-6xl" data-id="element-106" data-mp="1nt3dlzbwnw19">
        <div className="mx-auto max-w-3xl text-center" data-id="element-107" data-mp="1ivbkj1ziy3vh">
          <p className="text-[11px] font-semibold uppercase tracking-[.22em] text-sage-700" data-id="element-108" data-mp="1iw375nb58r9m">
            What is inside
          </p>
          <h2 className="mt-4 font-display text-[2.1rem] font-semibold uppercase leading-[1.02] tracking-[.01em] text-ink-900 sm:text-5xl" data-id="element-109" data-mp="2bk8oe02zny4p">
            6 professional volumes for your coaching business
          </h2>
        </div>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-110" data-mp="21l9pvabxtivf">
          {modules.map(({
          icon: Icon,
          kicker,
          title,
          description,
          features,
          accent
        }) => <article key={kicker} className="flex min-h-[280px] flex-col border border-line p-7" data-id="element-111" data-mp="q6nqagwss45s">
                <div className="flex items-center gap-3" data-id="element-112" data-mp="l69m59ybhed1">
                  <span className={`grid h-10 w-10 place-items-center ${accent}`} data-id="element-113" data-mp="1iupbup4z9ku5">
                    <Icon className="h-4 w-4 text-white" data-id="element-114" data-mp="1nt0jct7svj97" />
                  </span>
                  <p className="text-[11px] font-semibold uppercase tracking-[.18em] text-sage-700" data-id="element-115" data-mp="18xu9tw9hx2b4">
                    {kicker}
                  </p>
                </div>
                <h3 className="mt-6 font-display text-2xl font-semibold leading-tight text-ink-900" data-id="element-116" data-mp="104qzhwu5d5kp">
                  {title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-600" data-id="element-117" data-mp="14w90gkw6765o">
                  {description}
                </p>
                <p className="mt-auto border-t border-line pt-5 text-[11px] font-semibold uppercase tracking-[.12em] text-ink-800" data-id="element-118" data-mp="q4gpel3ese9r">
                  {features}
                </p>
              </article>)}
        </div>
      </div>
    </section>;
}